module.exports = __webpack_public_path__ + "img/5.02070c03.jpg";